module.exports = __webpack_public_path__ + "static/img/vision.5407917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/vision.png
// module id = RkR8
// module chunks = 0